import { avatars } from "@/mocks/homeData";
import type { MemeItem } from "@/mocks/homeData";
import SectionHeader from "./SectionHeader";

interface Props {
  onOpen: (item: MemeItem) => void;
}

export default function AvatarSection({ onOpen }: Props) {
  return (
    <section id="avatar" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeader
          eyebrow="吃瓜头像"
          title="换上瓜系头像 一秒入戏"
          desc="适合各平台吃瓜冲浪的专属头像，可爱、高冷、躺平、看戏总有一款戳中你。点击即可放大查看并保存。"
        />
        <div className="mt-9 flex flex-wrap justify-center gap-5 md:gap-7">
          {avatars.map((av) => (
            <button
              key={av.id}
              type="button"
              onClick={() => onOpen(av)}
              className="group flex w-[30%] max-w-[170px] min-w-[120px] flex-col items-center cursor-pointer"
              aria-label={`查看头像${av.title}`}
            >
              <span className="block w-full rounded-full border-4 border-background-50 bg-accent-100 p-2 shadow-sm transition-transform duration-300 group-hover:scale-105 group-hover:-translate-y-1">
                <img
                  src={av.img}
                  alt={av.alt}
                  className="aspect-square w-full rounded-full object-cover object-top"
                />
              </span>
              <span className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-accent-700">
                {av.title}
              </span>
              <span className="text-xs text-foreground-400">{av.tag}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}